const MOBILE_MEDIA_QUERY = '(max-width: 1023px)';

class EksterBar extends HTMLElement {
  connectedCallback() {
    this.openHandler = () => this.open();
    this.closeHandler = () => this.close();
    this.addEventListener('menu-blocks:open', this.openHandler);
    this.addEventListener('menu-blocks:close', this.closeHandler);

    this.mobileMediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    this.onMediaQueryChange = () => this.onBreakpointChange();
    this.mobileMediaQuery.addEventListener('change', this.onMediaQueryChange);

    this.setupObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('menu-blocks:open', this.openHandler);
    this.removeEventListener('menu-blocks:close', this.closeHandler);
    this.mobileMediaQuery?.removeEventListener('change', this.onMediaQueryChange);
    this.observer?.disconnect();
    this.observer = null;
  }

  setupObserver() {
    const spacer = document.querySelector('.levitate-spacer');
    if (!spacer) return;

    this.observer = new IntersectionObserver(([entry]) => {
      if (!this.mobileMediaQuery.matches || this.classList.contains('open')) return;
      document.body.classList.toggle('levitate', !entry.isIntersecting);
    });

    this.observer.observe(spacer);
  }

  onBreakpointChange() {
    if (!this.mobileMediaQuery.matches) {
      document.body.classList.remove('levitate');
    }
  }

  open() {
    this.classList.add('open');
    document.querySelector('[data-menu-blocks="backdrop"]')?.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('open');
    document.querySelector('[data-menu-blocks="backdrop"]')?.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('ekster-bar', EksterBar);
